import React, { useState, useContext } from 'react'
import { Form, Row, Col, Button } from 'react-bootstrap'
import { LanguageContext } from '../Language/LanguageContext'
import { HeaderTitle, NotifyContext, Loading } from '../Library'
import DatePicker from "react-datepicker";
import "./CreatebookingLocation.css"
import { setHours, setMinutes } from 'date-fns';
import { repeatStatus } from './BookingStatus';
import { createBookingLocation } from '../Network/Booking'
import { useHistory } from 'react-router-dom'

function CreateBookingLocation() {
    const history = useHistory()
    const notify = useContext(NotifyContext)
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.booking

    const [isLoading, setIsLoading] = useState(false)
    const [locationName, setLocationName] = useState("")
    const [detail, setDetail] = useState("")
    const [openTime, setOpentime] = useState(setHours(setMinutes(new Date(), 0), 9))
    const [closeTime, setCloseTime] = useState(setHours(setMinutes(new Date(), 0), 21))
    const [openType, setOpentype] = useState(repeatStatus.EVERY_DAY)
    const [imageFile, setImageFile] = useState(null)
    const [isError, setIsError] = useState(false)
    const [maxPeople, setMaxPeople] = useState("")

    const submit = () => {
        if(!locationName || !detail || !openTime || !closeTime || !maxPeople){
            notify.showNotify(lang.not_complete, lang.not_complete_desc, 1)
            setIsError(true)
            return
        }

        setIsLoading(true)
        createBookingLocation(locationName, detail, openTime, closeTime, openType, imageFile, maxPeople,
            (data)=>{
                console.log(data)
                notify.showNotify(lang.created_location, lang.created_location_desc, 0)
                setIsLoading(false)
                history.push("/booking")
            },
            (error)=>{
                setIsLoading(false)
            })
    }

    return (
        <div>
            { isLoading ? <Loading/> : null }
            <HeaderTitle title={lang.create_location} isShowBack={true} backTo="/booking"/>
            <Row>
                <Col md={10} lg={8} xl={6}>
                    <Form
                    onSubmit={(e)=>{
                        e.preventDefault()
                        submit()
                    }}
                    >
                        <Form.Group>
                            <Form.Label>{lang.location_name}</Form.Label>
                            <Form.Control
                            value={locationName}
                            onChange={(e)=>setLocationName(e.target.value)}
                            isInvalid={isError && !locationName}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.detail}</Form.Label>
                            <Form.Control 
                            value={detail}
                            onChange={(e)=>setDetail(e.target.value)}
                            isInvalid={isError && !detail}
                            as="textarea"/>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.open_time}</Form.Label>
                            <DatePicker
                            className="form-control"
                            selected={openTime}
                            dateFormat={"H:mm"}
                            onChange={(date)=>{setOpentime(date)}}
                            showTimeSelect
                            showTimeSelectOnly
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.close_time}</Form.Label>
                            <DatePicker
                            minTime={new Date(openTime)}
                            maxTime={setHours(setMinutes(new Date(), 59), 23)}
                            className="form-control"
                            selected={closeTime}
                            dateFormat={"H:mm"}
                            onChange={(date)=>{setCloseTime(date)}}
                            showTimeSelect
                            showTimeSelectOnly
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.open_type}</Form.Label>
                            <Form.Control 
                            value={openType}
                            onChange={(e)=>setOpentype(e.target.value)}
                            as="select">
                                <option value={repeatStatus.EVERY_DAY}>{lang.everyday}</option>
                                <option value={repeatStatus.EVERY_WEEKDAY}>{lang.everyweekday}</option>
                                <option value={repeatStatus.EVERY_WEEKEND}>{lang.everyweekend}</option>
                            </Form.Control>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.max_people_every_half_hour}</Form.Label>
                            <Form.Control
                            min={1}
                            type="number"
                            value={maxPeople}
                            onChange={(e)=>setMaxPeople(e.target.value)}
                            isInvalid={isError && !maxPeople}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.location_image}</Form.Label>
                            <Form.File
                            accept="image/*"
                            onChange={(e)=>{ 
                                const file = e.target.files[0]
                                setImageFile(file)
                            }}
                            />
                        </Form.Group>
                        
                        <hr/>
                        <Button type="submit">
                            {lang.create_location}
                        </Button>
                    </Form>
                </Col>
            </Row>
            
        </div>
    )
}

export default CreateBookingLocation
